import type { Language } from '../../stores/app-store';

// Languages that use right-to-left text direction
const RTL_LANGUAGES: Language[] = ['ar', 'fa', 'ckb'];

export function isRTL(language: Language): boolean {
  return RTL_LANGUAGES.includes(language);
}

export function getTextDirection(language: Language): 'ltr' | 'rtl' {
  return isRTL(language) ? 'rtl' : 'ltr';
}
